import { Button, Card, CardContent, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import locale from 'dayjs/locale/de';
import { useEffect, useState } from 'react';
import useNotification from '../../hooks/useNotification';
import { IAbsence, absenceTypes } from '../../interfaces/Types';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { addAbsences } from '../../store/thunks/absencesThunks';
import HolidayUtils from '../../utils/HolidayUtils';
import DateRangePicker from '../common/DateRangePicker';

const NewAbsence = () => {
  const profile = useAppSelector((state) => state.auth.profile);
  const [range, setRange] = useState<Dayjs[] | null>(null);
  const [absenceType, setAbsenceType] = useState<string | null>(null);
  const [absences, setAbsences] = useState<IAbsence[]>([]);
  const { notifyContext } = useNotification();

  const dispatch = useAppDispatch();

  // The DateRangePicker component is used to select a range of dates.
  const onChange = (dateRange: Dayjs[]) => setRange(dateRange);

  // The effect is triggered whenever the range or absenceType changes.
  useEffect(() => {
    setAbsences(() => {
      if (!range || !absenceType) {
        return [];
      }

      return range
        .filter((item) => HolidayUtils.checkIsWorkday(profile!.workingdays, item.locale({ ...locale }), profile!.state))
        .map((item) => ({ day: item.locale({ ...locale }).format('YYYY-MM-DD'), absencetype: absenceType }) as IAbsence);
    });
  }, [range, absenceType]);

  // The requestAbsence function is called when the user clicks the "Beantragen" button.
  const requestAbsence = () => {
    if (!absenceType) {
      notifyContext.addNotification('Es wurde keine Abwesenheitsart augewählt', 'error');
    } else {
      if (absences.length > 0) {
        dispatch(addAbsences(absences));
        notifyContext.addNotification('Abwesenheit wurde gespeichert', 'success');
      }
    }
  };

  return (
    <Card>
      <CardContent>
        <Stack spacing={4}>
          <DateRangePicker onChange={onChange} />

          <FormControl fullWidth>
            <InputLabel>Abwesenheitsart</InputLabel>
            <Select
              value={absenceType || 'Urlaub'}
              label="Abwesenheitsart"
              onChange={(e) => setAbsenceType(e.target.value as string)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 128,
                    width: 250,
                  },
                },
              }}>
              {absenceTypes.flatMap((absence) => (
                <MenuItem key={absence} value={absence}>
                  {absence}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button fullWidth variant="contained" onClick={requestAbsence} color="secondary">
            <Typography variant="button" display="block" color="text.primary">
              Beantragen
            </Typography>
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
export default NewAbsence;
